import React, { useState } from 'react'
import { formatTime } from '../../utils/time.utils'
import { useSelector } from 'react-redux'

import styles from '../../styles/components/admin/invoice.module.css'
import Input from '../UI/Input'
import useInput from '../../hooks/input.hook'
import * as icons from '../source/Icons.source'
import useAdminApi from '../../API/admin.api'
import * as authSelectors from '../../redux/selectors/auth.selectors'
import useInvoiceApi from '../../API/invoice.api'


function Invoice({invoice, refresh=()=>{}}) {
    const access = useSelector(authSelectors.adminAccess)
    const editAccess = (access === 'ADMIN' || access === 'SUPPORT')
    const finalAccess = (access === 'ADMIN')

    const amount = useInput(invoice?.amount)
    const adminApi = useAdminApi()
    const invoiceApi = useInvoiceApi()
    
    const [isWait, setIsWait] = useState(false)

    const [isOpenForseConfirm, setIsOpenForseConfirm] = useState(false)
    const [isOpenForseReject, setIsOpenForseReject] = useState(false)
    
    const [isOpenConfirm, setIsOpenConfirm] = useState(false)
    const [isOpenReject, setIsOpenReject] = useState(false)


    const forseConfirm = async () => {
        if(!isOpenForseConfirm) { return setIsOpenForseConfirm(true) }
        setIsWait(true)

        await adminApi.forseConfirm(invoice._id, amount.value)

        refresh(() => setIsWait(false))
        setIsOpenForseConfirm(false)
    }

    const forseReject = async () => {
        if(!isOpenForseReject) { return setIsOpenForseReject(true) }
        setIsWait(true)

        await adminApi.forseReject(invoice._id)

        refresh(() => setIsWait(false))
        setIsOpenForseReject(false)
    }

    const confirm = async () => {
        if(!isOpenConfirm) { return setIsOpenConfirm(true) }
        setIsWait(true)

        if(invoice.emergent) { await adminApi.confirmEmergent(invoice._id)}
        else { await adminApi.confirmInvoice(invoice._id) }

        refresh(() => setIsWait(false))
        setIsOpenConfirm(false)
    }

    const reject = async () => {
        if(!isOpenReject) { return setIsOpenReject(true) }
        setIsWait(true)

        if(invoice.emergent) { await adminApi.rejectEmergent(invoice._id) }
        else { await adminApi.rejectInvoice(invoice._id) }
        
        refresh(() => setIsWait(false))
        setIsOpenReject(false)
    }

    const sendCallback = async () => {
        await invoiceApi.sendCallback(invoice._id)
    }

    return (
        <div className={styles.main}>
            <div>{invoice?.emergent && "IS TECH"} {invoice?.amount} ₴</div>
            <div>{invoice?.cardNumber}</div>
            <div>{invoice?.workerName || invoice?.worker}</div>
            <div>{invoice?.partnerName || invoice?.partner}</div>
            <div>{invoice?.clientId}</div>
            <div>{invoice?._id}</div>
            <div className={`${styles.status} ${invoice?.status}`}>{invoice?.status}</div>

            <div>
                {editAccess && <>
                    {invoice?.status === 'REJECT' && !isWait && <>
                        <Input input={amount} className={styles.input}/>
                        <button className={`${styles.button} ${styles.forse_button}`} onClick={() => forseConfirm()}>
                            {icons.check}
                        </button>
                    </>}

                    {invoice?.status === 'CONFIRM' && !isWait && <>
                        <button className={`${styles.button} ${styles.forse_button}`} onClick={() => forseReject()}>
                            {icons.dismis} 
                        </button>
                    </>}

                    {invoice?.status === 'WAIT' && !isWait && (invoice.emergent || finalAccess) && <>
                        <button className={`${styles.button} ${styles.forse_button}`} onClick={() => confirm()}>
                            {icons.check}
                        </button>
                        <button className={`${styles.button} ${styles.forse_button}`} onClick={() => reject()}>
                            {icons.dismis}
                        </button>
                    </>}

                    {(invoice?.status === 'CONFIRM' || invoice?.status === 'REJECT') && <>
                        <button className={`${styles.button}`} onClick={() => sendCallback()}>
                            Clb
                        </button>
                    </>}
                </>}
            </div>

            <div className={styles.date}>
                {formatTime(invoice?.createdAt).replaceAll(',', " ")}
            </div>
        </div>
      )
}

export default Invoice